/* unplugin-vue-components disabled */import script from "./dept-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./dept-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./dept-dialog.vue?vue&type=style&index=0&id=6909855b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6909855b"]])

export default __exports__